module.exports = require("@swa-ui/core/src/SlideIntoView/SlideIntoView.module.scss");